import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client';
export const USER_PREFERENCES_SETTINGS_FIELDNAME = 'userPreferencesSettings';
export const GET_USER_PREFERENCES_SETTINGS = registerQuery({
  fieldName: USER_PREFERENCES_SETTINGS_FIELDNAME,
  args: [],
  fetcher: () => {
    return http.get('notification/preferences/v2/preferences');
  }
});
export const WORKFLOW_NOTIFICATIONS_SETTINGS_FIELDNAME = 'workflowNotificationsSettings';
export const WORKFLOW_NOTIFICATIONS_SUBSCRIPTIONS_SETTINGS_FIELDNAME = 'workflowNotificationsSubscriptionsSettings';
export const GET_WORFKLOW_NOTIFICATIONS_SUBSCRIPTIONS_SETTINGS = registerQuery({
  fieldName: WORKFLOW_NOTIFICATIONS_SUBSCRIPTIONS_SETTINGS_FIELDNAME,
  args: ['flowId'],
  fetcher({
    flowId
  }) {
    return http.get(`automationnotifications/v1/subscriptions/settings/${flowId}`).catch(error => {
      // 404 means that no settings have been found for this flow
      if (error.status === 404) {
        return {
          flowId,
          subscribedUserIds: [],
          subscribedTeamIds: [],
          notificationConfigs: [],
          lastUpdatedAt: undefined,
          lastUpdatedByUserId: undefined
        };
      } else {
        throw error;
      }
    });
  }
});
export const UPDATE_WORKFLOW_NOTIFICATIONS_SUBSCRIPTIONS_SETTINGS = registerMutation({
  fieldName: WORKFLOW_NOTIFICATIONS_SUBSCRIPTIONS_SETTINGS_FIELDNAME,
  args: ['flowId', 'subscribedUserIds', 'subscribedTeamIds', 'notificationConfigs', 'outdatedIfLastUpdatedMoreRecentThan'],
  fetcher({
    flowId,
    subscribedUserIds,
    subscribedTeamIds,
    notificationConfigs,
    outdatedIfLastUpdatedMoreRecentThan
  }) {
    return http.post('automationnotifications/v1/subscriptions/settings', {
      data: {
        flowId,
        subscribedUserIds,
        subscribedTeamIds,
        notificationConfigs,
        outdatedIfLastUpdatedMoreRecentThan
      }
    });
  }
});